import React from "react";
import usePagination from "hooks/usePagination";

const Pagination = ({
	onPageChange, afterPageChange,
	totalCount, siblingCount = 1,
	currentPage, pageSize,
}) => {

	const paginationRange = usePagination({
		currentPage, totalCount, siblingCount, pageSize
	});

	if (currentPage === 0 || paginationRange.length < 2)
		return <></>;


	const changeUrl = (page) => {
		const url = new URL(window.location);
		if (page === 1) url.searchParams.delete("page");
		else url.searchParams.set("page", page);
		window.history.pushState({}, "", url);
	};

	const changePage = (pageNumber) => {
		onPageChange(pageNumber);
		changeUrl(pageNumber);
		afterPageChange && afterPageChange();
	};

	const onNext = () => changePage(currentPage + 1);

	const onPrevious = () => changePage(currentPage - 1);

	const lastPage = paginationRange[paginationRange.length - 1];

	return (
		<div className="flex justify-center mt-10 md:mt-20 px-5">
			{currentPage !== 1 && <span className="pagination-item" onClick={onPrevious} role="button" tabIndex={0}>«</span>}
			{paginationRange.map((pageNumber, idx) => pageNumber === "..." ?
				<span key={`p-${idx}`} className="pagination-item">&#8230;</span> :
				<span
					key={idx}
					className={`pagination-item ${pageNumber === currentPage ? "!border-black" : ""}`}
					onClick={() => changePage(pageNumber)}
					role="button"
					tabIndex={0}>
					{pageNumber}
				</span>
			)}
			{lastPage !== currentPage && <span className="pagination-item" onClick={onNext} role="button" tabIndex={0}>»</span>}
		</div>
	);
};

export default Pagination;
